// The three credentials a front-end attaches with (V6 plan 13.3.1 "Credentials"; docs/HEADLESS.md
// section 2). Each call carries exactly one:
// - an account key, `Authorization: Bearer v5k_…` (or `X-Api-Key: v5k_…`): a server credential
//   for CLIs, integrations, bots and jobs. It is refused where `document` exists, so a key never
//   runs in a page;
// - a bearer session, `Authorization: Bearer v5s_…`: a first-party page on another origin that
//   signed in with `identity.exchange {delivery: "bearer"}`. The token may be a function, read
//   on every call, so a page can swap it after a fresh exchange; one that yields nothing sends no
//   Authorization, and the call is anonymous;
// - the session cookie: V5's own site, same origin, sent with `credentials: "include"`.
// The client sends any value it is given: the server, not the client, decides what a token is.
/** Refuses a credential this runtime must not hold: an account key in a page. */
export function assertCredentialAllowed(credential) {
    if (credential.kind !== "apiKey")
        return;
    if (typeof globalThis.document !== "undefined")
        throw new TypeError("an account key (v5k_) is a server credential and is refused in a page; a page signs in to a bearer session or uses the site's cookie");
}
/** The headers that carry the credential; none for the cookie, which the browser attaches. */
export async function credentialHeaders(credential) {
    if (credential === null || credential.kind === "cookie")
        return {};
    if (credential.kind === "apiKey")
        return credential.header === "x-api-key"
            ? { "x-api-key": credential.key }
            : { authorization: `Bearer ${credential.key}` };
    const token = typeof credential.token === "function" ? await credential.token() : credential.token;
    return token ? { authorization: `Bearer ${token}` } : {};
}
/**
 * The fetch `credentials` mode: the cookie's calls include it; every other call omits cookies,
 * since a key or a bearer is the one credential and no cookie crosses an origin (the server never
 * sends Access-Control-Allow-Credentials).
 */
export function credentialsMode(credential) {
    return credential?.kind === "cookie" ? "include" : "omit";
}
//# sourceMappingURL=credentials.js.map